module.exports = __webpack_public_path__ + "img/image32.27091645.jpg";